import { c as _c } from "react/compiler-runtime";
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ReactNode, useId } from 'react';
import { Divider } from '@/components/Divider';
import { ContextMenuButton } from '@/components/form/baseInputs/Button/ContextMenuButton';
import { ArrowDownIcon } from '@/components/icons/ArrowDownIcon';
import { ArrowUpIcon } from '@/components/icons/ArrowUpIcon';
import { ChevronDownIcon } from '@/components/icons/ChevronDownIcon';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Trash01Icon } from '@/components/icons/Trash01Icon';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { COLORS } from '@/styles/tokens/colors';
import { TYPOGRAPHY_SIZING } from '@/styles/tokens/fonts';
import { RecursiveAnswerNode } from './recursiveAnswer';
import { recursiveItemSummary } from './recursiveReviewSummary';
export function RecursiveReviewItem(t0) {
  const $ = _c(36);
  const {
    node,
    position,
    count,
    expanded,
    onToggle,
    onMove,
    onDelete,
    children
  } = t0;
  const contentId = useId();
  let t1;
  if ($[0] !== node || $[1] !== position) {
    t1 = recursiveItemSummary(node, position);
    $[0] = node;
    $[1] = position;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const summary = t1;
  const t2 = `${expanded ? "Collapse" : "Expand"} item ${position}: ${summary.title}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flex: 1,
      minWidth: 0,
      px: 2,
      py: 1.5,
      gap: 1.5,
      textAlign: "left",
      justifyContent: "flex-start"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== expanded) {
    t4 = expanded ? <ChevronDownIcon size={16} /> : <ChevronRightIcon size={16} />;
    $[4] = expanded;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ...TYPOGRAPHY_SIZING["body-xs"],
      overflowWrap: "anywhere"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== summary.title) {
    t6 = <Typography variant="body-s" fontWeight={600} sx={t5}>{summary.title}</Typography>;
    $[7] = summary.title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== summary.subtitle) {
    t7 = summary.subtitle && <Typography variant="body-xs" sx={{
      color: COLORS.TEXT.SECONDARY,
      overflowWrap: "anywhere"
    }}>{summary.subtitle}</Typography>;
    $[9] = summary.subtitle;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <Stack minWidth={0} flex={1}>{t6}{t7}</Stack>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== contentId || $[15] !== expanded || $[16] !== onToggle || $[17] !== t2 || $[18] !== t4 || $[19] !== t8) {
    t9 = <ButtonBase onClick={onToggle} aria-expanded={expanded} aria-controls={contentId} aria-label={t2} sx={t3}>{t4}{t8}</ButtonBase>;
    $[14] = contentId;
    $[15] = expanded;
    $[16] = onToggle;
    $[17] = t2;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== count || $[22] !== onDelete || $[23] !== onMove || $[24] !== position) {
    t10 = onDelete && <ContextMenuButton size="xs" variant="transparent" aria-label={`Item ${position} actions`}><MenuItem icon={<ArrowUpIcon size={16} />} label="Move up" disabled={!onMove || position === 1} onClick={() => onMove?.(-1)} /><MenuItem icon={<ArrowDownIcon size={16} />} label="Move down" disabled={!onMove || position === count} onClick={() => onMove?.(1)} /><Divider noMargin={true} /><MenuItem icon={<Trash01Icon size={16} />} label="Delete item" variant="destructive" onClick={onDelete} /></ContextMenuButton>;
    $[21] = count;
    $[22] = onDelete;
    $[23] = onMove;
    $[24] = position;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = <Stack direction="row" alignItems="center" gap={0.5} pr={2} borderBottom={`1px solid ${COLORS.GRAY[200]}`}>{t9}{t10}</Stack>;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const t12 = !expanded;
  let t13;
  if ($[29] !== children || $[30] !== contentId || $[31] !== t12) {
    t13 = <Box id={contentId} hidden={t12}>{children}</Box>;
    $[29] = children;
    $[30] = contentId;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t11 || $[34] !== t13) {
    t14 = <Box minWidth={0}>{t11}{t13}</Box>;
    $[33] = t11;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}